import React, { Fragment, Component } from 'react';
import
{
    Card, CardBody, Col, Button, Input, InputGroup, InputGroupAddon, Table, FormGroup, Label, Alert, Modal, ModalBody, ModalFooter, ModalHeader
} from 'reactstrap';
import { toast, Slide } from 'react-toastify';
import IMG01 from '../../assets/DVTools/images/ChannelMediaThumbs/Video-Icon.png';
import * as ticketsUtils from '../PlayerUI/js/video_tickets';
import BuyWithCreditCard from '../../helpers/Components/PayWithCreditCard';
export default class TicketsComponent extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            showPaymentButton: false,
            selectedTicket: null,
            paymentInfo: null,
            new_ticket_info: null,
            showEmailPopup: false,
            
        }
    }
    onSelectTicket = (item) =>
    {
        if (item)
        {
            this.setState({ showPaymentButton: true, selectedTicket: item })
            ticketsUtils.get_account_payment_data(this)
        }
    }
    payByCreditCard = (card_info) =>
    {
        this.setState({ card_info: card_info }, () =>
        {
            ticketsUtils.insert_ticket_order(this);
        })

    }
    onClickApplyButton = () =>
    {
        this.props.onClickApplyButton();
    }
    onChangeTokenValue = (e) =>
    {
        this.setState({ video_token: e.target.value });
        this.props.onChangeTokenValue(e.target.value);
    }
    onUseTicketButtonClick = (item) =>
    {
        this.setState({ video_token: item.token }, () =>
        {
            this.props.onChangeTokenValue(item.token, true);
        })
    }
    onShowEmailPopupClick = () =>
    {
        this.setState({ showEmailPopup: true })
    }
    closeEmailPopup = () =>
    {
        this.setState({ showEmailPopup: false })
    }
    onChangeEmailValue = (e) =>
    {
        this.setState({ email: e.target.value });
    }
    send_email = () =>
    {
        ticketsUtils.send_email(this);
    }
    showToast(msg, AlertType)
    {
        this.toastId = toast(msg, {
            transition: Slide,
            closeButton: true,
            autoClose: 5000,
            position: 'bottom-center',
            type: AlertType,
        });
    }
    onCloseCreditCardPopup = () => { }
    render()
    {
        return <Card>
            <CardBody className="pt-0">
                <Col md="10" className="mx-auto">
                    <Card tabs="true" className="mb-3">
                        <CardBody>
                            <table style={{ width: "100%" }}>
                                <tr >
                                    <td style={{ width: "2%" }}>
                                        <img src={IMG01} width="100px" height="80px" />
                                    </td>
                                    <td style={{ width: "96%", }}>
                                        <span style={{ marginLeft: "2%", fontSize: "14px" }}>{this.props.videoData.video_title}</span><br />
                                        <span style={{ marginLeft: "2%" }}>{this.props.videoData.video_desc}</span>
                                    </td>

                                </tr>

                            </table>
                            <div style={{ marginTop: "2.5%" }}>
                                <h5>This Video Requires Ticket</h5>
                                <br />
                                {this.props.videoData.new_ticket !== "" ? <Fragment>
                                    <Table className="mb-0">
                                        <thead>
                                            <tr>
                                                <td>Ticket</td>
                                                <td>Ticket number</td>
                                                <td>Transaction number</td>
                                                <td>Order number</td>
                                                <td>Actions</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.new_ticket_info !== null && this.props.new_ticket_info !== undefined ? this.props.new_ticket_info.map((item) =>
                                            {
                                                return <tr>
                                                    <td>{item.description}</td>
                                                    <td>{item.token}</td>
                                                    <td>{item.transaction_id}</td>
                                                    <td>{item.order_guid}</td>
                                                    <td>
                                                        <Fragment>
                                                            <Button color="primary" onClick={() => { this.onUseTicketButtonClick(item) }}>Use ticket</Button>
                                                            <Button onClick={this.onShowEmailPopupClick} style={{ marginLeft: "1%" }} color="primary">Send ticket to your email</Button>
                                                        </Fragment>
                                                    </td>
                                                </tr>
                                            }) : null}
                                        </tbody>
                                    </Table>
                                </Fragment> :
                                    <Fragment><InputGroup style={{ width: "50%", display: "inline-flex" }}>
                                        <Input placeholder="Ticket number" defaultValue={this.props.videoData.video_token} value={this.state.video_token} onChange={this.onChangeTokenValue} />
                                        <InputGroupAddon addonType="append">
                                            <Button color="secondary" onClick={this.onClickApplyButton}>Apply ticket</Button>
                                        </InputGroupAddon>
                                    </InputGroup>
                                        <span style={{ paddingLeft: "1%", paddingRight: "1%" }}>OR Buy One</span>
                                    </Fragment>
                                }
                                {/*<Button color="secondary" style={{ height: "38px", marginTop: "-.5%" }} onClick={this.props.showBuyTicketPart}>Buy One</Button>*/}
                                {this.props.showPaypalButton === true ?
                                    <Fragment>
                                        <br />
                                        <br />
                                        {this.props.videoData.new_ticket === "" ?
                                            <Table className="mb-0">
                                                <thead>
                                                    <tr>
                                                        <td> </td>
                                                        <td>Tickets</td><td>Price</td></tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.listTickets.map((item) =>
                                                    {
                                                        return <tr>
                                                            <td><FormGroup check>
                                                                <Label check>
                                                                    <Input type="radio" onClick={() => { this.onSelectTicket(item) }} name="radio1" style={{ marginTop: "-3%" }} />{' '}
                                                                </Label>
                                                            </FormGroup></td>
                                                            <td>{item.description}</td>
                                                            <td>{"$" + item.price}</td>
                                                        </tr>
                                                    })}
                                                </tbody>
                                            </Table>
                                            : null}
                                        {this.state.showPaymentButton === true ? <div>
                                            <Button onClick={() => { ticketsUtils.get_account_payment_data(this) }} style={{ display: "none" }}>Buy Now</Button>
                                        </div> : null}
                                        {this.state.paymentInfo !== null && this.state.paymentInfo.type === 2 ?
                                            <BuyWithCreditCard Title="Buy Ticket"
                                                Price={this.state.selectedTicket.price}
                                                payByCreditCard={this.payByCreditCard}
                                                onCloseCreditCardPopup={this.onCloseCreditCardPopup}/>
                                            : this.state.selectedTicket !== null ? < Button color="primary" style={{ height: "38px", marginTop: ".5%" }}
                                                onClick={() => { ticketsUtils.insert_ticket_order(this) }}>Buy Now</Button> : null}
                                    </Fragment>
                                    : null}
                                {this.props.videoData.token_status !== "" ?
                                    <Alert color="danger" style={{ marginTop: "2%" }}>{this.props.videoData.token_status}</Alert> : null}
                            </div>
                            <Modal isOpen={this.state.showEmailPopup} toggle={this.closeEmailPopup}>
                                <ModalHeader>
                                    <Label>Send Email</Label>
                                </ModalHeader>
                                <ModalBody>
                                    <FormGroup>
                                        <Label for="email">Email </Label>
                                        <Input type="text" name="email" id="email" 
                                            placeholder="Enter your email" onChange={this.onChangeEmailValue} />
                                    </FormGroup>
                                    <ModalFooter>
                                        <Button style={{ float: "right", }} color="primary" onClick={this.send_email} >Send</Button>
                                        <Button color="secondary" onClick={this.closeEmailPopup} style={{ float: "right", marginLeft: "1%"  }}>Cancel</Button>
                                    </ModalFooter>
                                </ModalBody>
                            </Modal>
                            
                        </CardBody>
                    </Card>
                </Col>
            </CardBody>
        </Card>
    }
}